var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 18.0593C7.44057 18.0593 5.74747 16.1299 5.74747 13.4393V4.65866C5.74747 1.96796 7.44057 0.0517578 9.99997 0.0517578C12.5594 0.0517578 14.2525 1.96796 14.2525 4.65866V13.4393C14.2525 16.1299 12.5594 18.0593 9.99997 18.0593ZM0.969971 13.7805V11.2212C0.969971 10.788 1.31127 10.4468 1.73127 10.4468C2.16437 10.4468 2.50557 10.788 2.50557 11.2212V13.728C2.50557 18.138 5.44557 21.1568 9.99997 21.1568C14.5544 21.1568 17.4944 18.138 17.4944 13.728V11.2212C17.4944 10.788 17.8356 10.4468 18.2688 10.4468C18.6888 10.4468 19.03 10.788 19.03 11.2212V13.7805C19.03 18.7418 15.7356 22.2462 10.7744 22.5743V26.1574H15.8669C16.2869 26.1574 16.6281 26.4987 16.6281 26.9187C16.6281 27.3518 16.2869 27.693 15.8669 27.693H4.13307C3.71307 27.693 3.37187 27.3518 3.37187 26.9187C3.37187 26.4987 3.71307 26.1574 4.13307 26.1574H9.23877V22.5743C4.26437 22.2462 0.969971 18.7418 0.969971 13.7805Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/MicOn.8e592528fe5fdd559545df77bea8abd5.svg";
export { ForwardRef as ReactComponent };